import validateFieldForPlaceholder from 'lib/validateFieldPlaceholder';
import React from 'react';

import RenderListTable from './RenderListTable';
import RenderListURL from './RenderListURL';
import RenderObjectRow from './RenderObjectRow';
import RenderTooltip from './RenderTooltip';
import { parseDate, parseStringNumberBool } from './utils';

const TableRenderer = ({ data, config, nested = false }) => {
  const processedConfig = config.filter(
    (item) =>
      item !== null && item !== '' && item !== undefined && item !== false,
  );

  return processedConfig.map(
    ({ name, key, type, config: nestedConfig, listConfig }) => {
      let value = data;
      const nestedKeys = key.split('.');
      for (const nestedKey of nestedKeys) {
        value = value ? validateFieldForPlaceholder(value[nestedKey]) : null;
      }

      if (type === 'object' && !nestedConfig) {
        return <RenderObjectRow key={key} data={value} label={name} />;
      }

      let formattedValue = null;
      switch (type) {
        case 'string':
        case 'boolean':
        case 'number':
          formattedValue = parseStringNumberBool(value);
          return (
            <tr key={key}>
              <td>{name}</td>
              <td>{formattedValue}</td>
            </tr>
          );
        case 'html':
          formattedValue = parseStringNumberBool(value);
          return (
            <tr>
              <td>{name}</td>
              <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {formattedValue !== validateFieldForPlaceholder('') ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: formattedValue + '' }}
                  ></div>
                ) : (
                  formattedValue
                )}
              </td>
            </tr>
          );
        case 'url':
          formattedValue = parseStringNumberBool(value);
          return (
            <tr>
              <td>{name}</td>
              <td>
                {String(formattedValue).includes('http') ? (
                  <a
                    href={`${
                      String(formattedValue).includes('http')
                        ? formattedValue
                        : '#'
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {formattedValue}
                  </a>
                ) : (
                  formattedValue
                )}
              </td>
            </tr>
          );
        case 'array':
          formattedValue =
            value && Array.isArray(value) && value.length > 0
              ? value.join(', ')
              : validateFieldForPlaceholder('');
          return (
            <tr>
              <td>{name}</td>
              <td>{formattedValue}</td>
            </tr>
          );
        case 'image':
          formattedValue = parseStringNumberBool(value);
          return (
            <tr>
              <td>{name}</td>
              <td>
                {formattedValue !== validateFieldForPlaceholder('') ? (
                  <img
                    src={`data:image/jpeg;base64,${formattedValue}`}
                    alt="screenshot"
                  />
                ) : (
                  validateFieldForPlaceholder('')
                )}
              </td>
            </tr>
          );
        case 'date':
          formattedValue = parseDate(value);
          return (
            <tr>
              <td>{name}</td>
              <td>{formattedValue}</td>
            </tr>
          );
        case 'object':
          const isValidObject = value !== validateFieldForPlaceholder({});
          return (
            <tr key={name}>
              {name !== '' && <td>{name}</td>}
              <td>
                {isValidObject ? (
                  <table>
                    <tbody>
                      <TableRenderer
                        data={value}
                        config={nestedConfig}
                        nested={true}
                      />
                    </tbody>
                  </table>
                ) : (
                  <span>{validateFieldForPlaceholder('')}</span>
                )}
              </td>
            </tr>
          );
        case 'listurl':
          return (
            <RenderListURL list={value} listConfig={listConfig} name={name} />
          );
        case 'list':
          return (
            <RenderListTable
              list={value}
              listConfig={listConfig}
              name={name}
              nestedCall={nested}
            />
          );
        case 'tooltip':
          const tooltip = value?.tooltip;
          const data = value.data;
          return <RenderTooltip value={data} label={name} tooltip={tooltip} />;
        default:
          return null;
      }
    },
  );
};

export default TableRenderer;
